import React, { useCallback } from 'react';
import ValueKeyLabel from "../../components/value-key-label/ValueKeyLabel";
import './skalia_display.css';
import { datamanagementAPI } from "../../api";
import WplButton from "../../components/wpl-button/WplButton";
import SimpleTable from "../../components/simple-table/SimpleTable";

export default function WindfarmDisplay({ windfarm }) {
    const download = useCallback(() => {
        datamanagementAPI
            .getWindfarmZip(windfarm)
            .then(signed_url => {
                window.open(signed_url, '_blank');
            });
    }, [windfarm]);

    return (<div className="skalia-display">
        <WplButton value="Download zip with images and excel" onClick={download}/>
        <div className="header">
            <ValueKeyLabel title="Windfarm">
                {windfarm.name}
            </ValueKeyLabel>
            <ValueKeyLabel title="Customer">
                {windfarm.customer}
            </ValueKeyLabel>
        </div>
        {Object.entries(windfarm.turbines).map(([turbineKey, turbine]) => (
            <div className="blade" key={turbineKey}>
                <h2>{turbine.name || turbineKey}</h2>
                {turbine.defects.map(defect =>
                    <div key={`${defect.blade}-${defect.report_defect_id}`} className="defect">
                        <SimpleTable headers={[
                            'Report Defect ID',
                            'Blade',
                            'Surface',
                            'Layer',
                            'Type',
                            'Distance',
                            'Severity',
                            'Image',
                        ]} rows={[defect]} renderRow={defect => <tr key={defect.report_defect_id}>
                            <td>{defect.report_defect_id}</td>
                            <td>{defect.blade}</td>
                            <td>{defect.surface}</td>
                            <td>{defect.layer}</td>
                            <td>{defect.type}</td>
                            <td>{defect.distance}</td>
                            <td>{defect.severity}</td>
                            <td><img className="preview-image" src={defect.small_path} alt={`Image with marked defect: ${defect.type}`}/></td>
                        </tr>}/>
                    </div>,
                )}
            </div>
        ))}
    </div>);
}
